import React, { useEffect, useState } from "react";
import { Box, Button, Flex, Stack, useMediaQuery } from "@chakra-ui/react";
import FavoriteButton from "../../Content/components/FavoriteButton";
import RelatedContentButton from "../../Content/components/RelatedContentButton";
import KnowledgeCardButton from "../../Content/components/KnowledgeCardButton";
import DeleteButton from "../../Content/components/DeleteButton";
import MoveButton from "../../Content/components/MoveButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faChevronLeft,
    faChevronRight,
} from "@fortawesome/free-solid-svg-icons";

interface OwnProps {
    onLinkContent: () => void;
}

export const ContentActionsButtons = ({ onLinkContent }: OwnProps) => {
    const [doesItFit] = useMediaQuery("(min-width: 1020px)");
    const [isShown, setIsShown] = useState(true);

    useEffect(() => {
        setIsShown(doesItFit);
    }, [doesItFit]);

    return (
        <>
            {!isShown && (
                <Button
                    variant="ghost"
                    onClick={() => {
                        setIsShown(true);
                    }}
                    leftIcon={<FontAwesomeIcon icon={faChevronRight} />}
                >
                    Content Actions
                </Button>
            )}
            {isShown && (
                <>
                    {!doesItFit && (
                        <Button
                            variant="ghost"
                            onClick={() => {
                                setIsShown(false);
                            }}
                            leftIcon={<FontAwesomeIcon icon={faChevronLeft} />}
                        >
                            Content Actions
                        </Button>
                    )}
                    <Flex
                        direction={doesItFit ? "row" : "column"}
                        marginY={4}
                        gap="4" justify="space-between"
                    >
                        <Stack
                            direction="row"
                            spacing={2}
                        >
                            <FavoriteButton />
                            <RelatedContentButton onLinkContent={onLinkContent} />
                            <KnowledgeCardButton />

                        </Stack>
                        <Stack
                            direction="row"
                            spacing={2}
                            >
                            <MoveButton />
                            <DeleteButton />
                        </Stack>
                    </Flex>
                </>
            )}
        </>
    );
};
